import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { colorCoreGray500, colorAccentLinkLight } from '@yme/tokens/colors';
export const DividerStyled = styled.div `
  height: 1px;
  background-color: ${colorCoreGray500};
`;
export const LinkStyled = styled(Link) `
  color: ${colorAccentLinkLight};
`;
